import { gql } from '@apollo/client';
import { changeBrowserLanguage, getCurrentLanguage, graphqlLocaleToI18n } from '@modernloop/i18n';

import { useInterviewerLocaleQuery } from 'src/interviewer-portal/generated/graphql';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const InterviewerLocaleQuery = gql`
  query InterviewerLocale {
    thisInterviewer {
      id
      locale
    }
  }
`;

/**
 * Syncs the interviewer's persisted locale to the browser language on load.
 * Mirrors useSyncEmployeeLocale (recruiting portal) but targets the interviewer schema.
 */
export function useSyncInterviewerLocale(): void {
  useInterviewerLocaleQuery({
    onCompleted: (data) => {
      const backendLocale = data?.thisInterviewer?.locale;
      if (!backendLocale) {
        return;
      }

      const i18nLocale = graphqlLocaleToI18n(backendLocale);
      if (!i18nLocale) {
        return;
      }

      const currentLocale = getCurrentLanguage();
      if (currentLocale !== i18nLocale) {
        changeBrowserLanguage(i18nLocale);
      }
    },
  });
}
